import * as Yup from "yup";

const getSettingSchema = (isEdit = false) =>
  Yup.object().shape({
    name: Yup.string()
      .label("name")
      .required()
      .max(255),
    value: Yup.string()
      .label("value")
      .required()
      .max(255),
    description: Yup.string()
      .label("description")
      .required()
      .max(255),
  });

export default getSettingSchema;
